import { getAdminAuthHeaders } from './adminApi';

const API_BASE_URL =
  process.env.REACT_APP_GOTTEA_API_BASE_URL ||
  'https://gottea-search-5gtrn.ondigitalocean.app';

async function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) {
    throw new Error(body.error || body.message || `Request failed with status ${response.status}`);
  }
  return body;
}

async function request(path, options = {}) {
  const authHeaders = await getAuthHeaders();
  const headers = {
    ...authHeaders,
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  return parseResponse(response);
}

// ---- Uploads ----

/** Fetch all vendor upload records, optionally filtered by token. */
export async function fetchVendorUploads(token) {
  const query = token ? `?token=${encodeURIComponent(token)}` : '';
  const data = await request(`/files/vendor-upload/uploads${query}`);
  return data.uploads || [];
}

// ---- Tokens ----

/** Fetch all vendor upload tokens. */
export async function fetchVendorTokens() {
  const data = await request('/files/vendor-upload/tokens');
  return data.tokens || [];
}

/** Create a new vendor upload token. */
export async function createVendorToken({ vendorName, description, expiresAt }) {
  const data = await request('/files/vendor-upload/create-token', {
    method: 'POST',
    body: JSON.stringify({ vendorName, description, expiresAt }),
  });
  return data;
}

/** Deactivate a vendor upload token. */
export async function deactivateVendorToken(token) {
  return request('/files/vendor-upload/deactivate-token', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });
}
